import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inSessionProperties } from '../../canvas/EditorSession';
import { StateProperty } from '../../canvas/ExtendableStore';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTools } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { annotateTool } from './AnnotateTool';
import { AnnotationOverlay } from './AnnotationOverlay';
import { AnnotationStore } from './AnnotationStore';
import { confettiTool } from './ConfettiTool';
import { FollowersInfo } from './FollowersInfo';
import { FollowingInfo } from './FollowingInfo';
import { FollowMechanics } from './FollowMechanics';
import { inGesturesCommands } from './GesturesCommands';
import { GesturesController } from './GesturesController';
import { GesturesInfo } from './GesturesInfo';
import { gesturesToolboxItem } from './GesturesToolboxItem';
import { PingMechanics } from './PingMechanics';
import { PingStore } from './PingStore';
import { pingTool } from './PingTool';
import { follow, pingCanvas, pingUI } from './PresentCommands';

export class PresentationPackage implements Package {

    public install = (host: PackageHost) => host
        .register(AnnotationOverlay, 'singleton', 'startable')
        .register(AnnotationStore, 'singleton')
        .register(PingStore, 'singleton')
        .register(PingMechanics, 'singleton', 'startable')
        .register(FollowMechanics, 'singleton', 'startable')
        .register(GesturesController, 'singleton', 'startable')
        .plug(inCommands(follow, pingCanvas, pingUI))
        .plug(inGesturesCommands())
        .plug(inSessionProperties(StateProperty.variable(FollowersInfo, FollowersInfo.empty)))
        .plug(inSessionProperties(StateProperty.variable(FollowingInfo, FollowingInfo.empty)))
        .plug(inSessionProperties(StateProperty.variable(GesturesInfo, GesturesInfo.empty)))
        .plug(inTools(annotateTool, pingTool, confettiTool))
        .plug(inToolboxItems(gesturesToolboxItem))
        ;
}
